import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  assignEmployeeAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post("employee/privilege/assign", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
